[
  { "code": "en", "name": "English", "status": "complete" },
  { "code": "de", "name": "Deutsch", "status": "complete" }
]
